import * as React from 'react'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
}

export const ConnectCalendarModal = ({ onClose }: Props) => {
  return (
    <Modal
      illustration="lightbulb"
      title={i18n.t('ats.schedule_interview.connect_calendar_modal.title')}
      description={i18n.t('ats.schedule_interview.connect_calendar_modal.description')}
      onClose={onClose}
    >
      <HelpCenterLink name="ats_calendar_sync">
        {i18n.t('ats.schedule_interview.connect_calendar_modal.cta_link')}
        {i18n.t('common.learn_more')}
      </HelpCenterLink>
    </Modal>
  )
}
